<div class="main-tab-title-box">
    <mat-card-title class="main-title">Scorecard</mat-card-title>
    <div>
        <analysis-options></analysis-options>
    </div>
</div>
<div *ngIf="loaderActive && !many_errors" class="div_loader_pag">
    <div  id="div_loader_pag">
      <div  class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysis will begin after you finish typing</div>
  </div>
  <div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>

<div *ngIf="short_words && !many_errors" class="message">
    <div class="line"></div>
    <p>Scorecard scores are not accurate on short documents. These scores should only be considered for larger (100 word+) documents.</p>
  </div>
  
<mat-card-content>
    <span>
        <button class="icon-button" (click)="exportar_data()" [disabled]="isButtonDisabled() || short_words" [ngClass]="{'disabled-button': (isButtonDisabled() || short_words)}">

            <span class="button-export">
                <div><img src="../assets/images/export-con.svg" class="export-con"></div><span>Scorecard
                    Export</span>
            </span>
            <!-- <mat-icon class="right-icon"
                [ngClass]="{'rotated-icon': isIconRotated, 'normal-icon': !isIconRotated}">expand_more</mat-icon> -->
        </button>
        <!-- <mat-menu #fileMenu="matMenu" (closed)="resetIcon()">
            <button mat-menu-item>Export Statistics And Details</button>
            <button mat-menu-item>Export Tagged Data</button>
        </mat-menu> -->
    </span>
    <!--SI HAY 18 PALABRAS O MAS EN ERRORS APARECE ESTE MENSAJE Y DESAPARECE LO DEMAS-->
    <div *ngIf="many_errors" class="scorecard-box">
        <div id="scorecard-title">ERRORS - {{ currentAnalysisMode }}</div>
        <div class="scorecard-title" style="margin-left: 0px;">Your text has too many SPELLING MISTAKES for a reliable Lexical Profile Score. <br> Please correct the errors and try again.</div>
    </div>
    <!----------------------------------------------------------------------------------->

    <div *ngIf="!many_errors && short_words || no_project" class="scorecard-box" style="grid-column: span 2;">
        <div id="scorecard-title">Lexical Profile ({{ currentAnalysisMode }})</div>
        <div class="scorecard-title" style="margin-bottom: 16px; margin-left: 0px;">This is the overall Lexical Profile for your {{
            currentAnalysisMode }}
            text. Your score is given as a percentage, with 100% indicating a high level native speaker Academic text.
            For the meaning of A1-C2 please see here.</div>
        <ng-container *ngIf="isScreenLarge; else mobileLayout">
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="scorecard-principal-box">
                    <div class="scorecard-title" style="margin-left: 4px;">Percentage</div>
                    <div class="spinner-container">
                        <div class="progress-circle">
                            <svg viewBox="0 0 36 36" class="circular-chart"> 
                                <path class="circle-bg"/> 
                                <path class="circle" /> 
                            </svg>
                        </div>


                        <div class="spinner-text">--
                            <div style="font-size: 15px; padding-bottom:8px ;">%</div>
                        </div>
                    </div>

                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">Metrics used</div>
                    <div class="scorecard-principal-value">--</div>
                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">CEFR Level</div>
                    <div class="scorecard-principal-value">--</div>
                </div>
            </div>
            <div class="scorecard-title" style="text-align: center; margin-top: 34px;">Key to CEFR Levels</div>
            <div class="scorecard-box-sub scroll_scores" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;">
                        A1
                    </div>
                    <div class="little-title">Beginner <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        style="margin-left: 7px;">
                        A2
                    </div>
                    <div class="little-title">Elementary <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        style="margin-left: 8px;">
                        B1
                    </div>
                    <div class="little-title">Intermediate <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        style="margin-left: 7px;">
                        B2
                    </div>
                    <div class="little-title">Upper <br> Intermediate</div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        style="margin-left: 7px;">
                        C1
                    </div>
                    <div class="little-title">Advanced <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        style="margin-left: 8px;">
                        C2
                    </div>
                    <div class="little-title">Proficiency <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        style="margin-left: 8px;">
                        D1
                    </div>
                    <div class="little-title">Academic <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        style="margin-left: 3px;">
                        D2
                    </div>
                    <div class="little-title">Upper <br> Academic</div>
                </div>
            </div>
            <div id="scorecard-title">Scorecard<div class="tooltip-container">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">This is calculated by dividing the unique words by the total number of words,
                    giving you a sense of how many unique words are used as a proportion of the total words.</span>
            </div></div>
            <div class="scorecard-title" style="margin-bottom: 16px;">These are the metrics used to calculate the Lexical Profile for your {{currentAnalysisMode}} text. These metrics have been identified in our research as statistically significant in distinguishing between different proficiency levels. If more metrics are used the score is likely to be more reliable. Click <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks" target="_blank" rel="noopener noreferrer"  >here</a> for more information.
                
            </div>
            
        </ng-container>
        <!--------------------->
        <!--------------------->
        <!--------------------->
        <!--------------------->
        <ng-template #mobileLayout>
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="scorecard-principal-box">
                    <div class="scorecard-title">Percentage</div>
                    <div class="spinner-container">
                    <div class="progress-circle" >
                        <svg viewBox="0 0 36 36" class="circular-chart"> 
                            <path class="circle-bg"/> 
                            <path class="circle" /> 
                        </svg>
                    </div>



                        <div class="spinner-text">--<div
                                style="font-size: 15px; padding-bottom:8px ;">%</div>
                        </div>
                    </div>

                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">Metrics used</div>
                    <div class="scorecard-principal-value">--</div>
                </div>

            </div>
            <div class="scorecard-box-sub scorecard-box-sub2"
                style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">CEFR Level</div>
                    <div class="scorecard-principal-value">--</div>
                </div>
            </div>
            <div class="scorecard-title" style="text-align: center; margin-top: 34px;" >Key to CEFR Levels</div>
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;">
                        A1
                    </div>
                    <div class="little-title">Beginner</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;">
                        A2
                    </div>
                    <div class="little-title">Elementary</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;">
                        B1
                    </div>
                    <div class="little-title">Intermediate</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px; margin-top: 18px;">
                        B2
                    </div>
                    <div class="little-title">Upper <br> Intermediate</div>
                </div>
            </div>

            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;">
                        C1
                    </div>
                    <div class="little-title">Advanced</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style=" margin-left: 8px;">
                        C2
                    </div>
                    <div class="little-title">Proficiency</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;">
                        D1
                    </div>
                    <div class="little-title">Academic</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px; margin-top: 17px;">
                        D2
                    </div>
                    <div class="little-title">Upper <br> Academic</div>
                </div>
            </div>
            <div id="scorecard-title">Scorecard<div class="tooltip-container">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">This is calculated by dividing the unique words by the total number of words,
                    giving you a sense of how many unique words are used as a proportion of the total words.</span>
            </div></div>
            <div class="scorecard-title" style="margin-bottom: 16px;">These are the metrics used to calculate the Lexical Profile for your {{currentAnalysisMode}} text. These metrics have been identified in our research as statistically significant in distinguishing between different proficiency levels. If more metrics are used the score is likely to be more reliable. Click <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks" target="_blank" rel="noopener noreferrer"  >here</a> for more information.
                
            </div>
        </ng-template>
        
    </div>




    <div *ngIf="!many_errors && !short_words && !no_project" class="scorecard-box" style="grid-column: span 2;">
        <div id="scorecard-title">Lexical Profile ({{ currentAnalysisMode }})</div>
        <div class="scorecard-title" style="margin-bottom: 16px; margin-left: 0px;">This is the overall Lexical Profile for your {{
            currentAnalysisMode }}
            text. Your score is given as a percentage, with 100% indicating a high level native speaker Academic text.
            For the meaning of A1-C2 please see here.</div>
        <ng-container *ngIf="isScreenLarge; else mobileLayout">
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="scorecard-principal-box">
                    <div class="scorecard-title" style="margin-left: 4px;">Percentage</div>
                    <div class="spinner-container">
                        <div class="progress-circle" [attr.data-percentage]="scorecard.summary.percentage ?? 0">
                            <svg viewBox="0 0 36 36" class="circular-chart"> 
                                <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/> 
                                <path class="circle" 
                                    [attr.stroke-dasharray]="scorecard.summary.percentage > 0 ? scorecard.summary.percentage + ', 100' : '0, 100'"
                                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/> 
                            </svg>
                        </div>


                        <div class="spinner-text">{{scorecard.summary.percentage ? scorecard.summary.percentage : "--"}}
                            <div style="font-size: 15px; padding-bottom:8px ;">%</div>
                        </div>
                    </div>

                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">Metrics used</div>
                    <div class="scorecard-principal-value">{{scorecard.summary.metrics ? scorecard.summary.metrics :
                        "--"}}</div>
                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">CEFR Level</div>
                    <div class="scorecard-principal-value">{{scorecard.summary.cefr_level ? scorecard.summary.cefr_level
                        : "--"}}</div>
                </div>
            </div>
            <div class="scorecard-title" style="text-align: center; margin-top: 34px;">Key to CEFR Levels</div>
            <div class="scorecard-box-sub scroll_scores" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        [ngClass]="{'matching': isMatchingLevel('A1'), 'not-matching': !isMatchingLevel('A1')}" style="margin-left: 8px;">
                        A1
                    </div>
                    <div class="little-title">Beginner <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        [ngClass]="{'matching': isMatchingLevel('A2'), 'not-matching': !isMatchingLevel('A2')}"
                        style="margin-left: 7px;">
                        A2
                    </div>
                    <div class="little-title">Elementary <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        [ngClass]="{'matching': isMatchingLevel('B1'), 'not-matching': !isMatchingLevel('B1')}"
                        style="margin-left: 8px;">
                        B1
                    </div>
                    <div class="little-title">Intermediate <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        [ngClass]="{'matching': isMatchingLevel('B2'), 'not-matching': !isMatchingLevel('B2')}"
                        style="margin-left: 7px;">
                        B2
                    </div>
                    <div class="little-title">Upper <br> Intermediate</div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        [ngClass]="{'matching': isMatchingLevel('C1'), 'not-matching': !isMatchingLevel('C1')}"
                        style="margin-left: 7px;">
                        C1
                    </div>
                    <div class="little-title">Advanced <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        [ngClass]="{'matching': isMatchingLevel('C2'), 'not-matching': !isMatchingLevel('C2')}"
                        style="margin-left: 8px;">
                        C2
                    </div>
                    <div class="little-title">Proficiency <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}"
                        style="margin-left: 8px;">
                        D1
                    </div>
                    <div class="little-title">Academic <br> <span style="visibility: hidden;">Intermediate</span></div>
                </div>
                <div class="vertical-box" style="border: none;">
                    <div class="scorecard-score-box"
                        [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}"
                        style="margin-left: 3px;">
                        D2
                    </div>
                    <div class="little-title">Upper <br> Academic</div>
                </div>
            </div>
            <div id="scorecard-title">Scorecard<div class="tooltip-container">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">This is calculated by dividing the unique words by the total number of words,
                    giving you a sense of how many unique words are used as a proportion of the total words.</span>
            </div></div>
            <div class="scorecard-title" style="margin-bottom: 16px;">These are the metrics used to calculate the Lexical Profile for your {{currentAnalysisMode}} text. These metrics have been identified in our research as statistically significant in distinguishing between different proficiency levels. If more metrics are used the score is likely to be more reliable. Click <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks" target="_blank" rel="noopener noreferrer"  >here</a> for more information.
                
            </div>
            
        </ng-container>
        <!--------------------->
        <!--------------------->
        <!--------------------->
        <!--------------------->
        <ng-template #mobileLayout>
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="scorecard-principal-box">
                    <div class="scorecard-title">Percentage</div>
                    <div class="spinner-container">
                    <div class="progress-circle" [attr.data-percentage]="scorecard.summary.percentage ?? 0">
                        <svg viewBox="0 0 36 36" class="circular-chart"> 
                            <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/> 
                            <path class="circle" 
                                [attr.stroke-dasharray]="scorecard.summary.percentage > 0 ? scorecard.summary.percentage + ', 100' : '0, 100'"
                                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/> 
                        </svg>
                    </div>



                        <div class="spinner-text">{{scorecard.summary.percentage ? scorecard.summary.percentage : "--"}}<div
                                style="font-size: 15px; padding-bottom:8px ;">%</div>
                        </div>
                    </div>

                </div>
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">Metrics used</div>
                    <div class="scorecard-principal-value">{{scorecard.summary.metrics ? scorecard.summary.metrics :
                        "--"}}</div>
                </div>

            </div>
            <div class="scorecard-box-sub scorecard-box-sub2"
                style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="scorecard-principal-box">
                    <div class="scorecard-principal-title">CEFR Level</div>
                    <div class="scorecard-principal-value">{{scorecard.summary.cefr_level ? scorecard.summary.cefr_level
                        : "--"}}</div>
                </div>
            </div>
            <div class="scorecard-title" style="text-align: center; margin-top: 34px;" >Key to CEFR Levels</div>
            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;"
                        [ngClass]="{'matching': isMatchingLevel('A1'), 'not-matching': !isMatchingLevel('A1')}">
                        A1
                    </div>
                    <div class="little-title">Beginner</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;"
                        [ngClass]="{'matching': isMatchingLevel('A2'), 'not-matching': !isMatchingLevel('A2')}">
                        A2
                    </div>
                    <div class="little-title">Elementary</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;"
                        [ngClass]="{'matching': isMatchingLevel('B1'), 'not-matching': !isMatchingLevel('B1')}">
                        B1
                    </div>
                    <div class="little-title">Intermediate</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px; margin-top: 18px;"
                        [ngClass]="{'matching': isMatchingLevel('B2'), 'not-matching': !isMatchingLevel('B2')}">
                        B2
                    </div>
                    <div class="little-title">Upper <br> Intermediate</div>
                </div>
            </div>

            <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;"
                        [ngClass]="{'matching': isMatchingLevel('C1'), 'not-matching': !isMatchingLevel('C1')}">
                        C1
                    </div>
                    <div class="little-title">Advanced</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style=" margin-left: 8px;"
                        [ngClass]="{'matching': isMatchingLevel('C2'), 'not-matching': !isMatchingLevel('C2')}">
                        C2
                    </div>
                    <div class="little-title">Proficiency</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px;"
                        [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}">
                        D1
                    </div>
                    <div class="little-title">Academic</div>
                </div>
                <div class="vertical-box cefr-box" style="border: none;">
                    <div class="scorecard-score-box" style="margin-left: 8px; margin-top: 17px;"
                        [ngClass]="{'matching': isMatchingLevel('D2'), 'not-matching': !isMatchingLevel('D2')}">
                        D2
                    </div>
                    <div class="little-title">Upper <br> Academic</div>
                </div>
            </div>
            <div id="scorecard-title">Scorecard<div class="tooltip-container">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">This is calculated by dividing the unique words by the total number of words,
                    giving you a sense of how many unique words are used as a proportion of the total words.</span>
            </div></div>
            <div class="scorecard-title" style="margin-bottom: 16px;">These are the metrics used to calculate the Lexical Profile for your {{currentAnalysisMode}} text. These metrics have been identified in our research as statistically significant in distinguishing between different proficiency levels. If more metrics are used the score is likely to be more reliable. Click <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks" target="_blank" rel="noopener noreferrer"  >here</a> for more information.
                
            </div>
        </ng-template>
        
    </div>


    <div  class="scorecard-box" *ngIf="getObjectKeys(scorecard.statistics).length!=0 && !many_errors  && !short_words">
        <div id="scorecard-title">Statistics</div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.averageSyllablesPerWord?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.averageSyllablesPerWord.score ? scorecard.statistics.averageSyllablesPerWord.score : "--"}} <div class="scorecard-title">Average syllables per word</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.averageSyllablesPerWord.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.averageSyllablesPerWord.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.averageSyllablesPerWord.cefrLevel ? scorecard.statistics.averageSyllablesPerWord.cefrLevel : "--"}}</div>
        </div>
        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.averageSyllablesPerSentence?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.averageSyllablesPerSentence.score ? scorecard.statistics.averageSyllablesPerSentence.score : "--"}} <div class="scorecard-title">Average syllables per sentence</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.averageSyllablesPerSentence.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.averageSyllablesPerSentence.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.averageSyllablesPerSentence.cefrLevel ? scorecard.statistics.averageSyllablesPerSentence.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.averageWordsPerSentence?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.averageWordsPerSentence.score ? scorecard.statistics.averageWordsPerSentence.score : "--"}} <div class="scorecard-title">Average words per sentence</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.averageWordsPerSentence.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.averageWordsPerSentence.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.averageWordsPerSentence.cefrLevel ? scorecard.statistics.averageWordsPerSentence.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.syllablesPer100Words?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.syllablesPer100Words.score ? scorecard.statistics.syllablesPer100Words.score : "--"}} <div class="scorecard-title">Syllables per 100 words</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.syllablesPer100Words.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.syllablesPer100Words.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.syllablesPer100Words.cefrLevel ? scorecard.statistics.syllablesPer100Words.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.wordsWithMoreThan2SyllablesPercentage?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.wordsWithMoreThan2SyllablesPercentage.score ? scorecard.statistics.wordsWithMoreThan2SyllablesPercentage.score : "--"}}% <div class="scorecard-title">Words with more than 2 syllables</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.wordsWithMoreThan2SyllablesPercentage.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.wordsWithMoreThan2SyllablesPercentage.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.wordsWithMoreThan2SyllablesPercentage.cefrLevel ? scorecard.statistics.wordsWithMoreThan2SyllablesPercentage.cefrLevel  : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.verbalElementsPerSentence?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.verbalElementsPerSentence.score ? scorecard.statistics.verbalElementsPerSentence.score : "--"}}% <div class="scorecard-title">Verbal elements per sentence</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.verbalElementsPerSentence.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.verbalElementsPerSentence.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.verbalElementsPerSentence.cefrLevel ? scorecard.statistics.verbalElementsPerSentence.cefrLevel  : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.nounElementsPerSentence?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.nounElementsPerSentence.score ? scorecard.statistics.nounElementsPerSentence.score : "--"}}% <div class="scorecard-title">Noun elements per sentence</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.nounElementsPerSentence.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.nounElementsPerSentence.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.nounElementsPerSentence.cefrLevel ? scorecard.statistics.nounElementsPerSentence.cefrLevel  : "--"}}</div>
        </div>

    </div>

    <div class="scorecard-box" *ngIf="!many_errors && !short_words &&
        (scorecard.statistics.LexicalDiversityVOCD?.score != null ||
        scorecard.statistics.LexicalDiversityMTLD?.score != null ||
        scorecard.statistics.lexicalDiversityMtld?.score != null)">
        <div id="scorecard-title">Lexical diversity</div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.LexicalDiversityVOCD?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.LexicalDiversityVOCD.score ? scorecard.statistics.LexicalDiversityVOCD.score : "--"}}% <div class="scorecard-title">Lexical diversity VOCD</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.LexicalDiversityVOCD.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.LexicalDiversityVOCD.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.LexicalDiversityVOCD.cefrLevel ? scorecard.statistics.LexicalDiversityVOCD.cefrLevel  : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.LexicalDiversityMTLD?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.LexicalDiversityMTLD.score ? scorecard.statistics.LexicalDiversityMTLD.score : "--"}}% <div class="scorecard-title">Lexical diversity MTLD</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.LexicalDiversityMTLD.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.LexicalDiversityMTLD.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.LexicalDiversityMTLD.cefrLevel ? scorecard.statistics.LexicalDiversityMTLD.cefrLevel  : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.lexicalDiversityMtld?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.lexicalDiversityMtld.score ? scorecard.statistics.lexicalDiversityMtld.score : "--"}}% <div class="scorecard-title">Lexical diversity MTLD</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.lexicalDiversityMtld.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.lexicalDiversityMtld.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.lexicalDiversityMtld.cefrLevel ? scorecard.statistics.lexicalDiversityMtld.cefrLevel  : "--"}}</div>
        </div>
    </div>

    <div class="scorecard-box" *ngIf="!many_errors && !short_words &&
        (scorecard.statistics.fleschReadingEase?.score != null ||
        scorecard.statistics.fleschKincaidReadingEase?.score != null ||
        scorecard.statistics.fleschReadingGrade?.score != null ||
        scorecard.statistics.fleschKincaidReadingGrade?.score != null ||
        scorecard.statistics.gunningFog?.score != null)">
        <div id="scorecard-title">Readability</div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.fleschReadingEase?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.fleschReadingEase.score ? scorecard.statistics.fleschReadingEase.score : "--"}}% <div class="scorecard-title">Flesch Kincaid Reading Ease</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.fleschReadingEase.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.fleschReadingEase.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.fleschReadingEase.cefrLevel ? scorecard.statistics.fleschReadingEase.cefrLevel  : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.fleschKincaidReadingEase?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.fleschKincaidReadingEase.score ? scorecard.statistics.fleschKincaidReadingEase.score : "--"}}% <div class="scorecard-title">Flesch Kincaid Reading Ease</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.fleschKincaidReadingEase.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.fleschKincaidReadingEase.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.fleschKincaidReadingEase.cefrLevel ? scorecard.statistics.fleschKincaidReadingEase.cefrLevel  : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.fleschReadingGrade?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.fleschReadingGrade.score ? scorecard.statistics.fleschReadingGrade.score : "--"}}% <div class="scorecard-title">Flesch Kincaid Reading Grade</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.fleschReadingGrade.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.fleschReadingGrade.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.fleschReadingGrade.cefrLevel ? scorecard.statistics.fleschReadingGrade.cefrLevel  : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.fleschKincaidReadingGrade?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.fleschKincaidReadingGrade.score ? scorecard.statistics.fleschKincaidReadingGrade.score : "--"}}% <div class="scorecard-title">Flesch Kincaid Reading Grade</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.fleschKincaidReadingGrade.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.fleschKincaidReadingGrade.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.fleschKincaidReadingGrade.cefrLevel ? scorecard.statistics.fleschKincaidReadingGrade.cefrLevel  : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.statistics.gunningFog?.score != null">
            <div class="scorecard-value">{{scorecard.statistics.gunningFog.score ? scorecard.statistics.gunningFog.score : "--"}}% <div class="scorecard-title">Gunning fog</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.statistics.gunningFog.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.statistics.gunningFog.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.statistics.gunningFog.cefrLevel ? scorecard.statistics.gunningFog.cefrLevel  : "--"}}</div>
        </div>
    </div>

    <div  class="scorecard-box" *ngIf="getObjectKeys(scorecard.evp).length!=0 && !many_errors  && !short_words">
        <div id="scorecard-title">Lexical Sophistication: English Vocabulary Profile</div>
        <div id="scorecard-box-sub" *ngIf="scorecard.evp.evpPercentOfWordsTypesAtA1Level?.score != null">
            <div class="scorecard-value">{{scorecard.evp.evpPercentOfWordsTypesAtA1Level.score ?
                scorecard.evp.evpPercentOfWordsTypesAtA1Level.score : "--"}}% <div class="scorecard-title">of words
                    (types) at A1 level</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.evp.evpPercentOfWordsTypesAtA1Level.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.evp.evpPercentOfWordsTypesAtA1Level.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.evp.evpPercentOfWordsTypesAtA1Level.cefrLevel ?
                scorecard.evp.evpPercentOfWordsTypesAtA1Level.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.evp.evpPercentOfWordsTokensAtB1Level?.score != null">
            <div class="scorecard-value">{{scorecard.evp.evpPercentOfWordsTokensAtB1Level.score ? scorecard.evp.evpPercentOfWordsTokensAtB1Level.score : "--"}}% <div class="scorecard-title">of words (tokens) at B1 level</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.evp.evpPercentOfWordsTokensAtB1Level.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.evp.evpPercentOfWordsTokensAtB1Level.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.evp.evpPercentOfWordsTokensAtB1Level.cefrLevel ? scorecard.evp.evpPercentOfWordsTokensAtB1Level.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.evp.evpPercentOfWordsTypesAtB1Level?.score != null">
            <div class="scorecard-value">{{scorecard.evp.evpPercentOfWordsTypesAtB1Level.score ?
                scorecard.evp.evpPercentOfWordsTypesAtB1Level.score : "--"}}% <div class="scorecard-title">of words
                    (types) at B1 level</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.evp.evpPercentOfWordsTypesAtB1Level.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.evp.evpPercentOfWordsTypesAtB1Level.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.evp.evpPercentOfWordsTypesAtB1Level.cefrLevel ?
                scorecard.evp.evpPercentOfWordsTypesAtB1Level.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.evp.evpPercentOfWordsTokensAtA1Level?.score != null">
            <div class="scorecard-value">{{scorecard.evp.evpPercentOfWordsTokensAtA1Level.score ? scorecard.evp.evpPercentOfWordsTokensAtA1Level.score : "--"}}% <div class="scorecard-title">of words (tokens) at A1 level</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.evp.evpPercentOfWordsTokensAtA1Level.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.evp.evpPercentOfWordsTokensAtA1Level.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.evp.evpPercentOfWordsTokensAtA1Level.cefrLevel ? scorecard.evp.evpPercentOfWordsTokensAtA1Level.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.evp.evpPercentOfWordsTokensAtB2Level?.score != null">
            <div class="scorecard-value">{{scorecard.evp.evpPercentOfWordsTokensAtB2Level.score ? scorecard.evp.evpPercentOfWordsTokensAtB2Level.score : "--"}}% <div class="scorecard-title">of words (tokens) at B2 level</div></div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.evp.evpPercentOfWordsTokensAtB2Level.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.evp.evpPercentOfWordsTokensAtB2Level.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">{{scorecard.evp.evpPercentOfWordsTokensAtB2Level.cefrLevel ? scorecard.evp.evpPercentOfWordsTokensAtB2Level.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.evp.evpPercentOfWordsTypesAtB2Level?.score != null">
            <div class="scorecard-value">{{scorecard.evp.evpPercentOfWordsTypesAtB2Level.score ?
                scorecard.evp.evpPercentOfWordsTypesAtB2Level.score : "--"}}% <div class="scorecard-title">of words
                    (types) at B2 level</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.evp.evpPercentOfWordsTypesAtB2Level.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.evp.evpPercentOfWordsTypesAtB2Level.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.evp.evpPercentOfWordsTypesAtB2Level.cefrLevel ?
                scorecard.evp.evpPercentOfWordsTypesAtB2Level.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.evp.evpPercentOfWordsTypesAtC1Level?.score != null">
            <div class="scorecard-value">{{scorecard.evp.evpPercentOfWordsTypesAtC1Level.score ?
                scorecard.evp.evpPercentOfWordsTypesAtC1Level.score : "--"}}% <div class="scorecard-title">of words
                    (types) at C1 level</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.evp.evpPercentOfWordsTypesAtC1Level.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.evp.evpPercentOfWordsTypesAtC1Level.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.evp.evpPercentOfWordsTypesAtC1Level.cefrLevel ?
                scorecard.evp.evpPercentOfWordsTypesAtC1Level.cefrLevel : "--"}}</div>
        </div>

    </div>

    <div   class="scorecard-box" *ngIf="getObjectKeys(scorecard.bnc).length!=0 && project_data.config_json.englishType == 'british' && !many_errors  && !short_words">
        <div id="scorecard-title">Lexical Sophistication: British National Corpus</div>

        <div id="scorecard-box-sub" *ngIf="scorecard.bnc.bncMeanLfcPer100Types?.score != null">
            <div class="scorecard-value">{{scorecard.bnc.bncMeanLfcPer100Types.score ?
                scorecard.bnc.bncMeanLfcPer100Types.score : "--"}}% <div class="scorecard-title">of words
                    (types) at 0-1K level</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.bnc.bncMeanLfcPer100Types.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.bnc.bncMeanLfcPer100Types.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.bnc.bncMeanLfcPer100Types.cefrLevel ?
                scorecard.bnc.bncMeanLfcPer100Types.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.bnc.bncPercentOfWordsTypesAt01kLevel?.score != null">
            <div class="scorecard-value">{{scorecard.bnc.bncPercentOfWordsTypesAt01kLevel.score ?
                scorecard.bnc.bncPercentOfWordsTypesAt01kLevel.score : "--"}}% <div class="scorecard-title">of words
                    (types) at 0-1K level</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.bnc.bncPercentOfWordsTypesAt01kLevel.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.bnc.bncPercentOfWordsTypesAt01kLevel.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.bnc.bncPercentOfWordsTypesAt01kLevel.cefrLevel ?
                scorecard.bnc.bncPercentOfWordsTypesAt01kLevel.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.bnc.bncPercentOfWordsTypesAt1020kLevel?.score != null">
            <div class="scorecard-value">{{scorecard.bnc.bncPercentOfWordsTypesAt1020kLevel.score ?
                scorecard.bnc.bncPercentOfWordsTypesAt1020kLevel.score : "--"}}% <div class="scorecard-title">of words
                    (types) at 10-20K level</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.bnc.bncPercentOfWordsTypesAt1020kLevel.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.bnc.bncPercentOfWordsTypesAt1020kLevel.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.bnc.bncPercentOfWordsTypesAt1020kLevel.cefrLevel ?
                scorecard.bnc.bncPercentOfWordsTypesAt1020kLevel.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.bnc.bnc50thPercentileTypes?.score != null">
            <div class="scorecard-value">{{scorecard.bnc.bnc50thPercentileTypes.score ?
                scorecard.bnc.bnc50thPercentileTypes.score : "--"}}<div class="scorecard-title">50th percentile (Types)
                </div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.bnc.bnc50thPercentileTypes.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.bnc.bnc50thPercentileTypes.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.bnc.bnc50thPercentileTypes.cefrLevel ? scorecard.bnc.bnc50thPercentileTypes.cefrLevel :
                "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.bnc.bnc60thPercentileTypes?.score != null">
            <div class="scorecard-value">{{scorecard.bnc.bnc60thPercentileTypes.score ?
                scorecard.bnc.bnc60thPercentileTypes.score : "--"}}<div class="scorecard-title">60th percentile (Types)
                </div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.bnc.bnc60thPercentileTypes.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.bnc.bnc60thPercentileTypes.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.bnc.bnc60thPercentileTypes.cefrLevel ? scorecard.bnc.bnc60thPercentileTypes.cefrLevel :
                "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.bnc.bnc70thPercentileTypes?.score != null">
            <div class="scorecard-value">{{scorecard.bnc.bnc70thPercentileTypes.score ?
                scorecard.bnc.bnc70thPercentileTypes.score : "--"}}<div class="scorecard-title">70th percentile (Types)
                </div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.bnc.bnc70thPercentileTypes.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.bnc.bnc70thPercentileTypes.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.bnc.bnc70thPercentileTypes.cefrLevel ? scorecard.bnc.bnc70thPercentileTypes.cefrLevel :
                "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.bnc.bnc80thPercentileTypes?.score != null">
            <div class="scorecard-value">{{scorecard.bnc.bnc80thPercentileTypes.score ?
                scorecard.bnc.bnc80thPercentileTypes.score : "--"}}<div class="scorecard-title">80th percentile (Types)
                </div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.bnc.bnc80thPercentileTypes.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.bnc.bnc80thPercentileTypes.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.bnc.bnc80thPercentileTypes.cefrLevel ? scorecard.bnc.bnc80thPercentileTypes.cefrLevel :
                "--"}}</div>
        </div>

    </div>

    <div  class="scorecard-box" *ngIf="getObjectKeys(scorecard.coca).length!=0 && project_data.config_json.englishType == 'american' && !many_errors  && !short_words">
        <div id="scorecard-title">Lexical Sophistication: Corpus of Contemporary American English</div>

        <div id="scorecard-box-sub" *ngIf="scorecard.coca.cocaMeanLfcPerType?.score != null">
            <div class="scorecard-value">{{scorecard.coca.cocaMeanLfcPerType.score ?
                scorecard.coca.cocaMeanLfcPerType.score : "--"}}% <div class="scorecard-title">COCA mean LFC per type</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.coca.cocaMeanLfcPerType.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.coca.cocaMeanLfcPerType.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.coca.cocaMeanLfcPerType.cefrLevel ?
                scorecard.coca.cocaMeanLfcPerType.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.coca.cocaPercentOfWordsTypesAt1020kLevel?.score != null">
            <div class="scorecard-value">{{scorecard.coca.cocaPercentOfWordsTypesAt1020kLevel.score ?
                scorecard.coca.cocaPercentOfWordsTypesAt1020kLevel.score : "--"}}% <div class="scorecard-title">of words
                    (types) at 10-20K level</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.coca.cocaPercentOfWordsTypesAt1020kLevel.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.coca.cocaPercentOfWordsTypesAt1020kLevel.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.coca.cocaPercentOfWordsTypesAt1020kLevel.cefrLevel ?
                scorecard.coca.cocaPercentOfWordsTypesAt1020kLevel.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.coca.coca50thPercentileTypes?.score != null">
            <div class="scorecard-value">{{scorecard.coca.coca50thPercentileTypes.score ?
                scorecard.coca.coca50thPercentileTypes.score : "--"}}<div class="scorecard-title">50th percentile
                    (Types)</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.coca.coca50thPercentileTypes.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.coca.coca50thPercentileTypes.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.coca.coca50thPercentileTypes.cefrLevel ? scorecard.coca.coca50thPercentileTypes.cefrLevel :
                "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.coca.coca60thPercentileTypes?.score != null">
            <div class="scorecard-value">{{scorecard.coca.coca60thPercentileTypes.score ?
                scorecard.coca.coca60thPercentileTypes.score : "--"}}<div class="scorecard-title">60th percentile
                    (Types)</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.coca.coca60thPercentileTypes.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.coca.coca60thPercentileTypes.cefrLevel?.includes('+')
              }"  style="background-color: #FCDCD2;">
                {{scorecard.coca.coca60thPercentileTypes.cefrLevel ? scorecard.coca.coca60thPercentileTypes.cefrLevel :
                "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.coca.coca70thPercentileTypes?.score != null">
            <div class="scorecard-value">{{scorecard.coca.coca70thPercentileTypes.score ?
                scorecard.coca.coca70thPercentileTypes.score : "--"}}<div class="scorecard-title">70th percentile
                    (Types)</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.coca.coca70thPercentileTypes.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.coca.coca70thPercentileTypes.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.coca.coca70thPercentileTypes.cefrLevel ? scorecard.coca.coca70thPercentileTypes.cefrLevel :
                "--"}}</div>
        </div>

        <div id="scorecard-box-sub" *ngIf="scorecard.coca.coca80thPercentileTypes?.score != null">
            <div class="scorecard-value">{{scorecard.coca.coca80thPercentileTypes.score ?
                scorecard.coca.coca80thPercentileTypes.score : "--"}}<div class="scorecard-title">80th percentile
                    (Types)</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.coca.coca80thPercentileTypes.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.coca.coca80thPercentileTypes.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.coca.coca80thPercentileTypes.cefrLevel ? scorecard.coca.coca80thPercentileTypes.cefrLevel :
                "--"}}</div>
        </div>

    </div>

    <div   class="scorecard-box" *ngIf="getObjectKeys(scorecard.awl).length!=0 && !many_errors  && !short_words">
        <div id="scorecard-title">Lexical Sophistication (academic)</div>
        <div id="scorecard-box-sub"
            *ngIf="scorecard.awl.academicWordListPercentOfAllAwlWordsTokensInTheText?.score != null">
            <div class="scorecard-value">{{scorecard.awl.academicWordListPercentOfAllAwlWordsTokensInTheText.score ?
                scorecard.awl.academicWordListPercentOfAllAwlWordsTokensInTheText.score : "--"}}% <div
                    class="scorecard-title">of all AWL words (tokens) in the text</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.awl.academicWordListPercentOfAllAwlWordsTokensInTheText.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.awl.academicWordListPercentOfAllAwlWordsTokensInTheText.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.awl.academicWordListPercentOfAllAwlWordsTokensInTheText.cefrLevel ?
                scorecard.awl.academicWordListPercentOfAllAwlWordsTokensInTheText.cefrLevel : "--"}}</div>
        </div>
        
        <div id="scorecard-box-sub"
            *ngIf="scorecard.awl.awlList1TokensPercent?.score != null">
            <div class="scorecard-value">{{scorecard.awl.awlList1TokensPercent.score ?
                scorecard.awl.awlList1TokensPercent.score : "--"}}% <div
                    class="scorecard-title">AWL list 1 Tokens %</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.awl.awlList1TokensPercent.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.awl.awlList1TokensPercent.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.awl.awlList1TokensPercent.cefrLevel ?
                scorecard.awl.awlList1TokensPercent.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub"
            *ngIf="scorecard.awl.academicWordListPercentOfAllAwlWordsTypesInTheText?.score != null">
            <div class="scorecard-value">{{scorecard.awl.academicWordListPercentOfAllAwlWordsTypesInTheText.score ?
                scorecard.awl.academicWordListPercentOfAllAwlWordsTypesInTheText.score : "--"}}% <div
                    class="scorecard-title">of all AWL words (types) in the text</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.awl.academicWordListPercentOfAllAwlWordsTypesInTheText.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.awl.academicWordListPercentOfAllAwlWordsTypesInTheText.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.awl.academicWordListPercentOfAllAwlWordsTypesInTheText.cefrLevel ?
                scorecard.awl.academicWordListPercentOfAllAwlWordsTypesInTheText.cefrLevel : "--"}}</div>
        </div>

        <div id="scorecard-box-sub"
            *ngIf="scorecard.awl.awlList1TypesPercent?.score != null">
            <div class="scorecard-value">{{scorecard.awl.awlList1TypesPercent.score ?
                scorecard.awl.awlList1TypesPercent.score : "--"}}% <div
                    class="scorecard-title">AWL list 1 Types %</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.awl.awlList1TypesPercent.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.awl.awlList1TypesPercent.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.awl.awlList1TypesPercent.cefrLevel ?
                scorecard.awl.awlList1TypesPercent.cefrLevel : "--"}}</div>
        </div>
    </div>

    <div class="scorecard-box" *ngIf="getObjectKeys(scorecard.metadiscourse).length!=0 && !many_errors  && !short_words">
        <div id="scorecard-title">Metadiscourse</div>
        <div id="scorecard-box-sub"
            *ngIf="scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText?.score != null">
            <div class="scorecard-value">
                {{scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText.score ?
                scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText.score : "--"}}%
                <div class="scorecard-title">of all metadiscourse markers (tokens) in the text</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText.cefrLevel ?
                scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTokensInTheText.cefrLevel : "--"}}
            </div>
        </div>
        <div id="scorecard-box-sub"
            *ngIf="scorecard.metadiscourse.metadiscoursePercentOfLogicalConnectivesTokens?.score != null">
            <div class="scorecard-value">
                {{scorecard.metadiscourse.metadiscoursePercentOfLogicalConnectivesTokens.score ?
                scorecard.metadiscourse.metadiscoursePercentOfLogicalConnectivesTokens.score : "--"}}% <div
                    class="scorecard-title">of all metadiscourse markers (types) in the text</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.metadiscourse.metadiscoursePercentOfLogicalConnectivesTokens.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.metadiscourse.metadiscoursePercentOfLogicalConnectivesTokens.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.metadiscourse.metadiscoursePercentOfLogicalConnectivesTokens.cefrLevel ?
                scorecard.metadiscourse.metadiscoursePercentOfLogicalConnectivesTokens.cefrLevel : "--"}}
            </div>
        </div>
        <div id="scorecard-box-sub"
            *ngIf="scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText?.score != null">
            <div class="scorecard-value">
                {{scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText.score ?
                scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText.score : "--"}}% <div
                    class="scorecard-title">of all metadiscourse markers (types) in the text</div>
            </div>
            <div [ngClass]="{
                'scorecard-score-box2': scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText.cefrLevel?.includes('+'),
                'scorecard-score-box': !scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText.cefrLevel?.includes('+')
              }" style="background-color: #FCDCD2;">
                {{scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText.cefrLevel ?
                scorecard.metadiscourse.metadiscoursePercentOfAllMetadiscourseMarkersTypesInTheText.cefrLevel : "--"}}
            </div>
        </div>
    </div>
    <div  *ngIf="!many_errors  && !short_words && !no_project" style="margin-top: 20px; margin-bottom: 20px;">
    <div class="scorecard-title" style="font: 18px;">Metrics not calculated</div>
        <div style="display: grid;grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));gap: 10px; margin-left: 10px; margin-top: 10px;">
            <ng-container *ngFor="let item of scorecard.metricsUsage">
                <div *ngIf="!item.usage" class="little-title" style="font: 14px;">
                    {{item.Name}}
                </div>
            </ng-container>
        </div>
    </div>

</mat-card-content>
